import {Box, Button, MenuItem, TextField, Typography} from '@mui/material';
import ProcessingType from 'library/src/processing/models/ProcessingType';
import wagoStatisticsApiService from 'library/src/statistic/services/WagoStatisticsApiService';
import {getCampaignTranslation} from 'modules/campaigns/services/CampaignsTranslation';
import {Blob} from 'node-fetch';
import React, {useEffect} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import {AppState} from 'shared/store';
const ExportAccountData: React.FC = () => {
  const intl = useIntl();
  const {campaigns, selectedCampaign} = useSelector<
    AppState,
    AppState['fields']
  >(({fields}) => fields);
  const {token} = useSelector<AppState, AppState['auth']>(({auth}) => auth);

  const [selectedCampaignId, setSelectedCampaign] = React.useState<
    number | null
  >(selectedCampaign || null);
  const [selectedService, setSelectedServcie] =
    React.useState<ProcessingType | null>(ProcessingType.IRRIGATION);

  const onExportClick = async () => {
    if (selectedCampaignId && token) {
      const response: Blob = await wagoStatisticsApiService.exportResumeData(
        token,
        selectedCampaignId,
        ProcessingType.IRRIGATION,
      );
      const downloadUrl = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = downloadUrl;

      // nom du fichier (tu peux le prendre de la réponse header "content-disposition")
      link.download = `export_campaign_${selectedCampaignId}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // libérer l’URL après usage
      window.URL.revokeObjectURL(downloadUrl);
    }
  };
  useEffect(() => {
    if (selectedCampaign && !selectedCampaignId) {
      setSelectedCampaign(selectedCampaign);
    }
  }, [selectedCampaign, selectedCampaignId]);
  return (
    <Box>
      <Typography variant='h6' pt={10}>
        <FormattedMessage id='export.modal.title' />
      </Typography>

      <Box my={6}>
        <Box my={6} width={1} display={'flex'} justifyContent={'space-between'}>
          <Box>
            {campaigns && (
              <TextField
                select
                label={intl.formatMessage({id: 'export.modal.campaign.label'})}
                variant='outlined'
                size='small'
                value={selectedCampaignId ? selectedCampaignId : ``}
                onChange={(event) => {
                  setSelectedCampaign(parseFloat(event.target.value) as number);
                }}>
                {campaigns
                  .sort((a, b) => a.campaign_id - b.campaign_id)
                  .map((element) => {
                    return (
                      <MenuItem
                        key={element.campaign_id}
                        value={element.campaign_id}>
                        {getCampaignTranslation(element)}
                      </MenuItem>
                    );
                  })}
              </TextField>
            )}{' '}
            <TextField
              select
              label={intl.formatMessage({id: 'export.modal.service.label'})}
              variant='outlined'
              size='small'
              value={selectedService ? selectedService : ``}
              onChange={(event) => {
                setSelectedServcie(event.target.value as ProcessingType);
              }}>
              <MenuItem
                key={ProcessingType.IRRIGATION}
                value={ProcessingType.IRRIGATION}>
                <FormattedMessage id='irrigation.headerButton.title' />
              </MenuItem>
            </TextField>
          </Box>
          <Button
            onClick={onExportClick}
            disabled={!selectedCampaignId}
            variant='contained'>
            <FormattedMessage id='export.modal.button' />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ExportAccountData;
